import React from 'react';

export default function ProjectionInfoPanel({ projection }) {
  return (
    <section className="gis-panel projection-info-panel">
      <h2>{projection.name}</h2>
      <dl className="info-grid">
        <div>
          <dt>EPSG</dt>
          <dd>{projection.epsg}</dd>
        </div>
        <div>
          <dt>Type</dt>
          <dd>{projection.type}</dd>
        </div>
        <div>
          <dt>Datum</dt>
          <dd>{projection.datum}</dd>
        </div>
        <div>
          <dt>Ellipsoid</dt>
          <dd>{projection.ellipsoid}</dd>
        </div>
        <div>
          <dt>Best for</dt>
          <dd>{projection.bestFor}</dd>
        </div>
        <div>
          <dt>Usage Area</dt>
          <dd>{projection.usage}</dd>
        </div>
        <div>
          <dt>Advantages</dt>
          <dd>{projection.advantages}</dd>
        </div>
        <div>
          <dt>Disadvantages</dt>
          <dd>{projection.disadvantages}</dd>
        </div>
        <div>
          <dt>Distortion</dt>
          <dd>{projection.distortion}</dd>
        </div>
      </dl>
      <p className="edu-note">{projection.educational}</p>
    </section>
  );
}
